<template>
    <div class="index-shell"
        style="position: absolute;left: 0px;top: 0px;padding: 0px;margin: 0px;display: flex;flex-direction: column;height: 100%;width: 100%;">

        <routerView :style="{ height: contentHeight + 'px' }"></routerView>
        <div id="tabBar" :style="{
            height: $store.state.indexBarHeight + 'px'
        }" style="width: 100%;height: 50px;padding: 0px;margin: 0px;display: flex;align-items: center;flex-shrink: 0;">
            <div @click="$router.push('/')"
                style="flex: 1;height: 100%;display: flex;justify-content: center;align-items: center;" :style="{
                    background: ($route.name == 'home' ? '#FCBC23' : 'white'),
                    color: ($route.name == 'home' ? 'white' : 'black')
                }">首页</div>
            <div @click="$router.push('/MessageList')"
                style="flex: 1;height: 100%;display: flex;justify-content: center;align-items: center;" :style="{
                    background: ($route.name == 'MessageList' ? '#FCBC23' : 'white'),
                    color: ($route.name == 'MessageList' ? 'white' : 'black')
                }">消息</div>
            <div @click="$router.push('/publishDynamic')"
                style="flex: 1;height: 100%;display: flex;justify-content: center;align-items: center;font-size:22px;font-weight:700;" :style="{
                    background: ($route.name == 'PublishDynamic' ? '#FCBC23' : 'white'),
                    color: ($route.name == 'PublishDynamic' ? 'white' : '#FCBC23')
                }">＋</div>
            <div @click="$router.push('/orderListView/-1')"
                style="flex: 1;height: 100%;display: flex;justify-content: center;align-items: center;"
                :style="{
                    background: ($route.name == 'OrderListView' ? '#FCBC23' : 'white'),
                    color: ($route.name == 'OrderListView' ? 'white' : 'black')
                }"
                >订单</div>
            <div @click="$router.push('/mineInfo')"
                style="flex: 1;height: 100%;display: flex;justify-content: center;align-items: center;"
                :style="{
                    background: ($route.name == 'mineInfo' ? '#FCBC23' : 'white'),
                    color: ($route.name == 'mineInfo' ? 'white' : 'black')
                }"
                >我的</div>
        </div>

    </div>
</template>

<script>
import request from "../axios/request";
export default {
    data() {
        return {
            contentHeight: null
        }
    },
    methods: {
    },
    mounted() {
        const resizeObserver = new ResizeObserver((entries) => {
            requestAnimationFrame(() => {
                for (const entry of entries) {
                    this.contentHeight = document.documentElement.clientHeight - entry.contentRect.height
                }
            });
        });
        resizeObserver.observe(document.getElementById("tabBar"));

    }
}
</script>

<style scoped>
@media (min-width:900px){.index-shell{max-width:1280px!important;left:50%!important;transform:translateX(-50%);box-shadow:0 0 18px #0002;background:#f4f5f6}}
</style>
